import * as React from "react";
import type { SVGProps } from "react";
const SvgLinkinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 7.714h3.81V22H2V7.714ZM3.893 5.81h-.02C2.734 5.81 2 4.962 2 3.904 2 2.823 2.758 2 3.915 2c1.16 0 1.873.823 1.895 1.904 0 1.058-.736 1.906-1.917 1.906ZM22 12.952a5.238 5.238 0 0 0-5.238-5.238 5.229 5.229 0 0 0-4.286 2.233V7.714h-3.81V22h3.81v-7.619a2.857 2.857 0 1 1 5.714 0V22H22v-9.048Z"
    />
  </svg>
);
export default SvgLinkinIcon;
